export default __webpack_public_path__ + "static/media/cover_large_08.94c82f2c.jpg";